import { IStyle } from '@fluentui/react';

export interface IIngestStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  buttons?: IStyle;
}

export interface IIngestClassNames {
  root: string;
  form: string;
  fields: string;
  buttons: string;
}

export const ingestStylesDefault: Partial<IIngestStyles> = {
  root: {
    flex: 1,
    paddingTop: 17,
    minHeight: 0,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    minHeight: 0,
    overflow: 'auto',
  },
  buttons: { textAlign: 'right', marginTop: 16 },
};
